import React from "react";

import GenericLoader from "src/images/loading.svg";
import WinkyLoader from "src/images/winky_loader.gif";

export interface SpinnerProps {
  alt: string;
  useUnbrandedIllustrations: boolean;
}

const Spinner = ({ alt, useUnbrandedIllustrations }: SpinnerProps) => {
  const src = useUnbrandedIllustrations ? GenericLoader : WinkyLoader;

  return <img src={src} alt={alt || "Loading..."} />;
};

export default Spinner;
